import { normalizePath } from "./path-utils"

export function resolvePdfUrl(params: {
  apiBase: string
  sessionId: string
  explicitPdfUrl?: string
  timestamp?: number
}): string {
  const stamp = params.timestamp ?? Date.now()
  const withTs = (url: string) => {
    const joiner = url.includes("?") ? "&" : "?"
    return `${url}${joiner}t=${stamp}`
  }

  if (params.explicitPdfUrl) {
    if (params.explicitPdfUrl.startsWith("http://") || params.explicitPdfUrl.startsWith("https://")) {
      return withTs(params.explicitPdfUrl)
    }
    return withTs(`${params.apiBase.replace(/\/$/, "")}/${params.explicitPdfUrl.replace(/^\//, "")}`)
  }

  return withTs(
    `${params.apiBase.replace(/\/$/, "")}/api/compiler/sessions/${encodeURIComponent(params.sessionId)}/pdf`,
  )
}

export function buildAssetUrlCandidates(params: {
  apiBase: string
  path: string
  templateId?: string
  sessionId?: string
}): string[] {
  const rawPath = params.path.trim()
  const normalized = normalizePath(params.path)
  if (!normalized && !rawPath.startsWith("data:")) return []

  const encodedPath = normalized
    .split("/")
    .map((segment) => encodeURIComponent(segment))
    .join("/")

  const base = params.apiBase.replace(/\/$/, "")
  const candidates = new Set<string>()

  if (rawPath.startsWith("http://") || rawPath.startsWith("https://") || rawPath.startsWith("data:")) {
    candidates.add(rawPath)
  }

  candidates.add(`${base}/${encodedPath}`)
  candidates.add(`${base}/api/v1/assets/${encodedPath}`)

  if (params.templateId) {
    candidates.add(
      `${base}/api/v1/templates/${encodeURIComponent(params.templateId)}/assets/${encodedPath}`,
    )
  }

  if (params.sessionId) {
    candidates.add(
      `${base}/api/v1/sessions/${encodeURIComponent(params.sessionId)}/assets/${encodedPath}`,
    )
  }

  return Array.from(candidates)
}
